// src/pages/Profile.jsx

import { Link } from "react-router-dom";
import { FaUser } from "react-icons/fa";
import { FiUser, FiLogOut } from "react-icons/fi";
import { useAuth } from "../api/AuthContext";
import { protectedTheme } from "./ui/protectedTheme";

export default function Profile() {
  const { user, logout } = useAuth();

  return (
    <div className={`${protectedTheme.page} flex flex-col items-center`}>
      {/* Header */}
      <div className="mb-6 w-full">
        <p className="text-center text-sm font-semibold uppercase tracking-[0.2em] text-emerald-700">
          Account
        </p>
        <h1 className="mt-1 text-center text-3xl font-black text-zinc-950">
          Profile
        </h1>
      </div>

      <div className="flex w-full max-w-xl flex-col items-center rounded-3xl bg-white p-6 shadow">
        <div className="flex h-24 w-24 items-center justify-center overflow-hidden rounded-full bg-emerald-950 text-lime-200">
          <FiUser className="text-5xl" />
          {/* <FiCamera className="absolute bottom-0 right-0 bg-white p-1 rounded-full text-2xl" /> */}
        </div>
        <p className="mt-4 text-lg font-black text-zinc-950">{user.firstName}</p>{" "}
        {/* First Name only */}
      </div>

      {/* Menu */}
      <div className="mt-6 w-full max-w-xl rounded-3xl bg-white p-3 shadow">
        <ProfileItem
          icon={<FaUser />}
          label="Edit Profile"
          to="/edit-profile"
        />
        {/* <ProfileItem
          icon={<FaLock />}
          label="Change Password"
          to="/change-password"
        /> */}

        {/* <ProfileItem
            icon={<FaQuestionCircle />}
            label="Help & Support"
            to="/help"
          /> */}
        <button
          onClick={logout}
          className="flex w-full items-center space-x-3 rounded-2xl px-3 py-3 text-left text-base font-semibold text-red-600 hover:bg-red-50"
        >
          <FiLogOut />
          <span>Logout</span>
        </button>
      </div>
    </div>
  );
}

// Component for each row
function ProfileItem({ icon, label, to }) {
  return (
    <Link
      to={to}
      className="flex items-center justify-between rounded-2xl px-3 py-4 hover:bg-emerald-50"
    >
      <div className="flex items-center space-x-3">
        <span className="text-emerald-700">{icon}</span>
        <span className="font-semibold text-zinc-800">{label}</span>
      </div>
      <span className="text-zinc-400">&gt;</span>
    </Link>
  );
}
